import View from './view.js';
import icons from 'url:../../img/icons.svg';

class PaginationView extends View {
  _parentElement = document.querySelector('.pagination');

  addHandlerClick(handler) {
    this._parentElement.addEventListener('click', function (e) {
      e.preventDefault();
      const btn = e.target.closest('.btn--inline');
      if (!btn) return;
      const goToPage = +btn.dataset.goto;
      handler(goToPage);
    });
  }

  _buttonNext(page) {
    return `<button data-goto=" ${
      page + 1
    }" class="btn--inline pagination__btn--next">
            <span>Page ${page + 1}</span>
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-right"></use>
            </svg>
          </button>`;
  }
  _buttonPrev(page) {
    return ` <button data-goto=" ${
      page - 1
    }" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Page ${page - 1}</span>
          </button>
          `;
  }
  _buttonBoth(page) {
    return `
      	  <button data-goto=" ${
            page - 1
          }" class="btn--inline pagination__btn--prev">
              <svg class="search__icon">
                <use href="${icons}#icon-arrow-left"></use>
              </svg>
              <span>Page ${page - 1}</span>
            </button>
      	  <button data-goto=" ${
            page + 1
          }" class="btn--inline pagination__btn--next">
              <span>Page ${page + 1}</span>
              <svg class="search__icon">
                <use href="${icons}#icon-arrow-right"></use>
              </svg>
            </button>`;
  }

  _generateMarkup() {
    const curPage = this._data.page;
    const numPages = Math.ceil(
      this._data.results.length / this._data.resultsPerPage
    );
    console.log(numPages);
    //page 1, and there are other pages
    if (curPage === 1 && numPages > 1) {
      return this._buttonNext(curPage);
      //   return `<button class="btn--inline pagination__btn--next">
      //         <span>Page ${curPage + 1}</span>
      //         <svg class="search__icon">
      //           <use href="${icons}#icon-arrow-right"></use>
      //         </svg>
      //       </button>`;
    }
    //last page
    if (curPage === numPages && numPages > 1) {
      return this._buttonPrev(curPage);

      //   return ` <button class="btn--inline pagination__btn--prev">
      //         <svg class="search__icon">
      //           <use href="${icons}#icon-arrow-left"></use>
      //         </svg>
      //         <span>Page ${curPage - 1}</span>
      //       </button>
      //       `;
    } //Other page
    if (curPage < numPages) {
      return this._buttonBoth(curPage);

      //   return `
      // 	  <button class="btn--inline pagination__btn--prev">
      //         <svg class="search__icon">
      //           <use href="${icons}#icon-arrow-left"></use>
      //         </svg>
      //         <span>Page ${curPage - 1}</span>
      //       </button>
      // 	  <button class="btn--inline pagination__btn--next">
      //         <span>Page ${curPage + 1}</span>
      //         <svg class="search__icon">
      //           <use href="${icons}#icon-arrow-right"></use>
      //         </svg>
      //       </button>`;
    }
    //Page 1, and there are no other pages
    return '';
  }
}

export default new PaginationView();
